import React from 'react';

// Convert to a simple functional component
function FooterComponents() {
    // We only return the JSX as there is no state or lifecycle methods needed
    return (
        <div>
            <footer className="footer bg-dark">
                <span className="text-white">All Rights Reserved 2025 @Avishkar Pansare</span>
            </footer>
        </div>
    );
}

export default FooterComponents;